import React from 'react'
import { connect } from 'react-redux';
import Loader from 'react-loader-spinner';
import actions from '../actions/index';
import '../src/transferCard.scss'
import {
  handedOut,
  invalidToActivate,
  getAbloyKey,
  isUpdating,
} from '../helpers/AbloyKeyHelper';
import AccessDetails from './key_activation/AccessDetails';

const mapStateToProps = state => {
  return {
    abloyKeys: state.abloyKeys,
    updatingKeys: state.updatingKeys,
  }
};

const mapDispatchToProps = dispatch => ({
  markAbloyKeyAsBusy: (abloyKey) => dispatch(actions.markAbloyKeyAsBusy(abloyKey)),
  checkAbloyKeyStatus: (leaseId, apartmentKeyId, abloyKey) => dispatch(actions.checkAbloyKeyStatus(leaseId, apartmentKeyId, abloyKey)),
  fetchAbloyKeyById: (leaseId, apartmentKeyId, abloyKey) => dispatch(actions.fetchAbloyKeyById(leaseId, apartmentKeyId, abloyKey)),
  removeAccessAbloyKey: (leaseId, customerId, apartmentKeyId, abloyKey) => dispatch(actions.removeAccessAbloyKey(leaseId, customerId, apartmentKeyId, abloyKey)),
  looseAbloyKey: (leaseId, customerId, apartmentKeyId, abloyKey) => dispatch(actions.looseAbloyKey(leaseId, customerId, apartmentKeyId, abloyKey)),
  brokenAbloyKey: (leaseId, customerId, apartmentKeyId, abloyKey) => dispatch(actions.brokenAbloyKey(leaseId, customerId, apartmentKeyId, abloyKey)),
  removeLeaseKey: (leaseId, item) => dispatch(actions.removeLeaseKey(leaseId, item)),
  looseLeaseKey: (leaseId, item) => dispatch(actions.looseLeaseKey(leaseId, item)),
  returnLeaseKey: (leaseId, item) => dispatch(actions.returnLeaseKey(leaseId, item)),
  giveLeaseKey: (leaseId, item) => dispatch(actions.giveLeaseKey(leaseId, item))
});

class KeyItem extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const item     = this.props.item;
    const leaseId  = this.props.lease.id;
    const abloyKey = getAbloyKey(this.props.abloyKeys, item);

    if (!abloyKey || !abloyKey.is_busy) { return }

    // In case when we are activating a new key
    if (item._new) { return }

    // In case we reload the page and the abloy key is still not programmed we need to check the progress
    this.props.checkAbloyKeyStatus(leaseId, item.id, abloyKey)
  }

  getIcon(item, abloyKey, updating) {
    const abloyKeyIsBusy = abloyKey && abloyKey.is_busy
    let abloyKeyIsProgrammed = !abloyKey || abloyKey.programmed
    if (abloyKey && !_.find(this.props.abloyUpdatingMessageStatus, (status) => abloyKey.where_at === status)) {
      abloyKeyIsProgrammed = true
    }
    if (updating || !this.props.inited || abloyKeyIsBusy) {
      return (<Loader type="Oval" color="#acafb1" height="20" width="20"/>)
    }

    return ((this.props.greenStatus == item.state && abloyKeyIsProgrammed) ? <i className='fa fa-check' /> : null);
  }

  /* computed */
  accessDetails(item, abloyKey, handedoutToCurrent, updating) {
    if (!this.props.inited) {
      return
    }

    if (!abloyKey || !abloyKey.identity) {
      return
    }

    return (
      <AccessDetails
        lease={this.props.lease}
        item={item}
        abloyKey={abloyKey}
        updating={updating}
        abloyUpdatingMessageStatus={this.props.abloyUpdatingMessageStatus}
        abloyKeyOperations={this.props.abloyKeyOperations}
        handedoutToCurrent={handedoutToCurrent}
        getKeyUpdates={this.props.fetchAbloyKeyById}
        removeAccessAK={this.props.removeAccessAbloyKey}
        markLostAK={this.props.looseAbloyKey}
        markBrokenAK={this.props.brokenAbloyKey}
      />
    )
  }

  btnRemove(leaseId, item, updating) {
    if (!_.find(this.props.apartmentKeyOperations, (op) => op == 'remove')) { return }

    return (
      <button
        className={"btn btn-action hover-btn"}
        onClick={()=>this.props.removeLeaseKey(leaseId, item)}
        disabled={(updating ? "disabled" : null)}
      >
        <i className="fa fa-times" aria-hidden="true" />
        <span className={"tooltiptext"}>Poista avain</span>
      </button>
    )
  }

  btnReturn(leaseId, item, updating) {
    if (!_.find(this.props.apartmentKeyOperations, (op) => op == 'return')) { return }

    return(
      <button
        className="btn btn-action"
        disabled={(updating ? "disabled" : null)}
        onClick={()=>this.props.returnLeaseKey(leaseId, item)}
      >
        <p>Palauta avain</p>
      </button>
    )
  }

  btnLoose(leaseId, item, updating) {
    if (!_.find(this.props.apartmentKeyOperations, (op) => op == 'loose')) { return }

    return (
      <button
        className={"btn btn-action hover-btn"}
        disabled={(updating ? "disabled" : null)}
        onClick={()=>this.props.looseLeaseKey(leaseId, item)}
      >
        <i className="fa fa-question-circle" aria-hidden="true" />
        <span className={"tooltiptext"}>Merkkaa hävinneeksi</span>
      </button>
    )
  }

  cbxGiveToCustomer(leaseId, item, abloyKey, updating) {
    if (item.state != 'received' && item.state != 'not_received') { return }
    if (!abloyKey) { return }

    if (!_.find(this.props.apartmentKeyOperations, (op) => op == 'give_to_customer')) { return }

    return (
      <div className={"card-cbx"}>
        <input
          id={"give_cbx" + item.id}
          type="checkbox"
          className={"btn btn-action hover-btn"}
          disabled={(updating ? "disabled" : null)}
          onChange={()=>(item.state == 'not_received' || confirm("Haluatko peruuttaa avaimen luovutuksen asukkaalle?") ? this.props.giveLeaseKey(leaseId, item) : void(0)) }
          checked={item.state == 'received' ? true : false}
        />
        <label htmlFor={"give_cbx" + item.id}>Luovutettu asiakkaalle</label>
      </div>
    )
  }

  givenKeyHelp(item, abloyKey) {
    if (item.state != 'received' && item.state != 'not_received') { return }
    if (!abloyKey) { return }

    if (!_.find(this.props.apartmentKeyOperations, (op) => op == 'give_to_customer')) { return }


    return (
      <span>Luodut avaimet kiinnitetään aina yhteen asukkaaseen, mutta niitä ei automaattisesti merkitä luovutetuiksi. Merkitse avain luovutetuksi yllä vasta kun se on oikeasti annettu asiakkaalle. Voit peruuttaa avaimen luovuttamisen poistamalla merkin valintaruudusta.</span>
    )
  }

  apartmentKeyActionsEnabled(abloyKey, handedoutToCurrent) {
    const needToCheckStatus = abloyKey && _.find(this.props.abloyUpdatingMessageStatus, (status) => status == abloyKey.where_at)

    if (abloyKey && !abloyKey.programmed && needToCheckStatus) { return false }
    if (!this.props.inited) { return false }
    if (abloyKey && abloyKey.is_busy) { return false }
    if (abloyKey && abloyKey.where_at != 'IN_STOCK' && handedoutToCurrent) { return false }

    return true
  }

  render() {
    const item     = this.props.item;
    const leaseId  = this.props.lease.id;
    const abloyKey = getAbloyKey(this.props.abloyKeys, item);

    const errorMsg = invalidToActivate(abloyKey, this.props.lease, this.props.possibleErrors);
    const handedoutToCurrent = handedOut(abloyKey, this.props.lease); //hanededout to current customer

    const btnEabled = this.apartmentKeyActionsEnabled(abloyKey, handedoutToCurrent)

    const updating = isUpdating(this.props.updatingKeys, item.id)
    if (item.state == "returned") {
      return (
        <div className="card-keys-stamp">
          <div className="card-row ">
            <div className="card-item">
              <p>Avaimen leima</p>
              <div className="card-keys-btn">
                <p>{item.stamp}</p>&nbsp;
                <p>(palautettu {item.marked_returned_at || item.returned_at || item.updated_at} {item.marked_returned_by})</p>
                {this.getIcon(item, abloyKey, updating)}
              </div>
            </div>
            {btnEabled ? this.btnLoose(leaseId, item, updating) : null}
            {btnEabled ? this.btnReturn(leaseId, item, updating) : null}
            {btnEabled ? this.btnRemove(leaseId, item, updating) : null}
          </div>
          <span className="error-msg">{errorMsg}</span>
          {this.accessDetails(item, abloyKey, handedoutToCurrent, updating)}
        </div>
      )
    } else if (item.state == "received") {
      return (
        <div className="card-keys-stamp">
          <div className="card-row ">
            <div className="card-item">
              <p>Avaimen leima</p>
              <div className="card-keys-btn">
                <p>{item.stamp}</p>&nbsp;
                <p>(luovutettu {item.marked_received_at} {item.marked_received_by})</p>
                {this.getIcon(item, abloyKey, updating)}
              </div>
            </div>
            {btnEabled ? this.btnLoose(leaseId, item, updating) : null}
            {btnEabled ? this.btnReturn(leaseId, item, updating) : null}
            {btnEabled ? this.btnRemove(leaseId, item, updating) : null}
            {this.cbxGiveToCustomer(leaseId, item, abloyKey, updating)}
          </div>
          {this.givenKeyHelp(item, abloyKey)}
          <span className="error-msg">{errorMsg}</span>
          {this.accessDetails(item, abloyKey, handedoutToCurrent, updating)}
        </div>
      )
    } else {
      return (
        <div className="card-keys-stamp">
          <div className="card-row ">
            <div className="card-item">
              <p>Avaimen leima</p>
              <div className="card-keys-btn">
                <p>{item.stamp}</p>
                {this.getIcon(item, abloyKey, updating)}
              </div>
            </div>
            {btnEabled ? this.btnLoose(leaseId, item, updating) : null}
            {btnEabled ? this.btnReturn(leaseId, item, updating) : null}
            {btnEabled ? this.btnRemove(leaseId, item, updating) : null}
            {this.cbxGiveToCustomer(leaseId, item, abloyKey, updating)}
          </div>
          {this.givenKeyHelp(item, abloyKey)}
          <span className="error-msg">{errorMsg}</span>
          {this.accessDetails(item, abloyKey, handedoutToCurrent, updating)}
        </div>
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(KeyItem)
